import { useContext, useMemo } from 'react';
import { useCollectionsPermissions } from '../useCollectionsPermissions';
import { useCollectionsLocation } from '../useCollectionsLocation';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';
import { computeDefaultDepartmentGroup } from './departmentGroup';

export const useDepartmentGroupDefault = () => {
  const { user } = useContext(AuthenticationContext);
  const { isCollectionsAdmin } = useCollectionsPermissions();
  const location = useCollectionsLocation();
  // department_groups is keyed by location; the "My groups" filter only applies to the
  // active Collections location, so pick that location's groups (group_ids collide across locations).
  const myGroups = useMemo(() => (location ? user?.department_groups?.[location] : []) ?? [], [user, location]);
  const defaultDepartmentGroup = useMemo(
    () => computeDefaultDepartmentGroup(isCollectionsAdmin, myGroups),
    [isCollectionsAdmin, myGroups],
  );
  const myGroupsLabel = useMemo(() => [...myGroups].sort().join(', '), [myGroups]);
  return { user, isCollectionsAdmin, myGroups, defaultDepartmentGroup, myGroupsLabel };
};
